module.exports = __webpack_public_path__ + "static/media/ic_videoMenu.74e7f5c1.svg";